import { render } from "./NSideMenu.vue?vue&type=template&id=335fa13b"
import script from "./NSideMenu.vue?vue&type=script&lang=js"
export * from "./NSideMenu.vue?vue&type=script&lang=js"

import "./NSideMenu.vue?vue&type=style&index=0&id=335fa13b&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__